// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".strip .strip-image{display:none}@media only screen and (max-width: 1199px){.strip.grid{display:block !important}}@media only screen and (min-width: 1200px){.strip .strip-image{display:block;width:64px;filter:hue-rotate(-134deg)}}\n", ""]);
// Exports
module.exports = exports;
